import { makeStyles } from "@mui/styles"

const useStyle = makeStyles(() => ({
  root: {
    width: "100%",
  },
  tableWrap: {
    height: "calc(70vh - 14rem)",
    overflow: "auto",
    "@media all and (min-width: 620px) and (max-width: 1200px)": {
      height: "calc(80vh - 20rem)",
      marginBottom: "1rem",
    },
    "@media all and (max-width: 620px)": {
      height: "calc(100vh - 25rem)",
      marginBottom: "1rem",
    },
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
  },
  tableBody: {
    background: "#f9f9f9",
  },
  titleEmpty: {
    fontSize: 16,
    fontWeight: "bold",
    color: "#4B4952",
    width: '100%',
    margin: '20px 0px',
    textAlign: 'center'
  },
}))

export default useStyle
